var operators = {
    gt: function (a, b) { return a > b; },
    eq: function (a, b) { return a === b; },
    lt: function (a, b) { return a < b; },
    all: function () { return true; },
};
export var comparison = function (row, columnId, value) {
    var filterValue = value[0], numberToCompareWith = value[1];
    var operator = filterValue.value;
    var rowValue = row.getValue(columnId);
    if (isNaN(numberToCompareWith) || numberToCompareWith === "")
        return true;
    return operators[operator](Number(rowValue), Number(numberToCompareWith));
};
